import Vue from 'vue'
import VueRouter from 'vue-router'
import Reports from '@/views/Reports'
import Login from '@/views/Login'
import Forgot from '@/views/Login/Forgot'
import Verify from '@/views/Login/Verify'

import { App, base, loggedOut } from '@/layouts'

import { logout, logoutFirst } from '@/lib/auth'
import YouRoutes from './you'
import NoNavRoutes from './no-nav'
import BillingRoutes from './billing'

Vue.use(VueRouter)

const routes = [
  {
    path: '/claim/user/:claim_token',
    component: loggedOut,
    beforeEnter: logoutFirst,
    children: [
      {
        name: 'claim/verify',
        path: 'verify',
        props: true,
        component: () => import('@/views/Claim/Verify'),
      },
      {
        name: 'claim/user',
        path: '',
        props: true,
        component: () => import('@/views/Claim/User'),
      },
    ]
  },
  {
    path: '/login',
    component: loggedOut,
    children: [
      {
        name: 'login',
        path: '',
        component: Login,
      },
      {
        name: 'forgot',
        path: 'forgot',
        component: Forgot,
      },
      {
        name: 'verify',
        path: 'verify',
        component: Verify,
      },
      {
        name: 'login/privacy',
        path: 'privacy',
        component: () => import('@/views/PrivacyPolicy'),
      },
      {
        name: 'login/tos',
        path: 'eula',
        component: () => import('@/views/TOS'),
      },
    ],
  },
  {
    name: 'logout',
    path: '/logout',
    beforeEnter: logout,
  },
  {
    path: '/new/:pro_token',
    component: loggedOut,
    beforeEnter: logoutFirst,
    children: [
      {
        name: 'new/pro/create',
        path: 'create',
        props: true,
        component: () => import('@/views/New/Create')
      },
      {
        name: 'new/pro',
        path: '',
        props: true,
        component: () => import('@/views/New'),
      },
    ]
  },
  ...NoNavRoutes,
  {
    path: '',
    component: App,
    children: [
      ...BillingRoutes,
      ...YouRoutes,
      {
        name: 'home',
        path: 'home',
        component: () => import('@/views/Leads/List'),
      },
      {
        path: 'leads',
        component: base,
        children: [
          {
            name: 'leads',
            path: ':lead_id',
            props: true,
            component: () => import('@/views/Leads/Show'), 
          },
        ],
      },
      {
        name: 'reports',
        path: 'reports',
        component: Reports,
      },
      {
        name: 'default',
        path: '*',
        redirect: { name: 'home' },
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
